import { useSeo } from "../lib/seo";
import { useData } from "../context/DataContext";
import { PageShell } from "../components/PageShell";
import { DecisionRow, EmptyState, GuestBanner } from "../components/DecisionList";

export default function FavouritesPage() {
  useSeo({ title: "Saved | DITHER", description: "Your saved DITHER decisions.", noindex: true });
  const { favourites, signedIn, removeFavourite } = useData();
  return (
    <PageShell title="Saved" subtitle="The verdicts worth keeping." testId="favourites-page">
      {!signedIn && <GuestBanner />}
      {favourites.length ? (
        <ul className="space-y-3" data-testid="favourites-list">
          {favourites.map((f, i) => <DecisionRow key={f.id} item={f} index={i} onRemove={() => removeFavourite(f.id)} />)}
        </ul>
      ) : (
        <EmptyState title="No favourites" body="Hit SAVE on any result to keep it here." />
      )}
    </PageShell>
  );
}
